const PortalRoutePaths = {
    Root: "/",
    Home: "/home",
    Sandbox: "/sandbox",
    EnvironmentConfig: "/environmentconfig",
    ImportHistoricResultsPage: "/stock-transfer-import-results/:id"
};

const PartitionRoutePaths = {
    CreatePartition: "/partition/create",
    ShowPartition: "/partition/details/:id",
    EditPartition: "/partition/edit/:id",
    Partitions: "/partition/list",
};

const AllocationRoutePaths = {
    AdjustmentAllocation: "/allocation/adjust",
    MovementAllocation: "/allocation/movement",
}

const PreAlertRoutPaths = {
    CreatePreAlert: "/pre-alert/create"
}

const ImportPaths = {
    StockTransferImport: "/imports/stock-transfer-import"
}

const NodesRoutePaths = {
    ManageNodes: "/nodes",
}

const ProductsRoutePath = {
    ManageProducts: "/add-managed-product",
}

const ProductRoutePath = {
    Product: "/product",
}

const ConsistencyCheckPath = {
    ConsistencyCheck: "/consistency-check",
}

const OtherPaths = {
    ReloadRoute: "/reload"
}
const routes = { ...PortalRoutePaths, ...PartitionRoutePaths, ...AllocationRoutePaths, ...PreAlertRoutPaths, ...ImportPaths, ...NodesRoutePaths, ...ProductsRoutePath, ...ConsistencyCheckPath, ...OtherPaths, ...ProductRoutePath };

export default routes;
